import React, { useEffect, useState, useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorCode, ResponceDataType } from "../../../../ErrorCode";

import Paper from '@material-ui/core/Paper';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Grid, { GridSpacing } from '@material-ui/core/Grid';

import { AppContext } from '../../../../App';
import { SettingsState } from '../../../organisms/SelectSettings';
import { useModal } from '../../../../function/useModal';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../atoms/Dialog/ConfirmDialog';
import MessageDialog, { MessageDialogResponse } from '../../../atoms/Dialog/MessageDialog';

import { GetPLCcollectSettingType, PLCcollectSettingType, SetPLCcollectSetting } from './CollectSettingDefine';
import CollectGridHeader from './CollectGridHeader';
import CollectGridBody from './CollectGridBody';
import CollectSettingFooter from './CollectSettingFooter';
import CollectGridHeaderIoT from './CollectGridHeaderIoT';
import CollectGridBodyIoT from './CollectGridBodyIoT';

type CollectSettingProps = {
  editData: SettingsState;
};

const useStyles = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 315px)',
      overflowX: 'scroll',
    },
    tableContainerIoT: {
      maxHeight: 'calc(100vh - 298px)',
      overflowX: 'scroll',
    },
  })
);

const setAllStartTime = () => {
  console.debug('saveAction');
};

const orderDevice = (source: PLCcollectSettingType[], plcOn: boolean, isDevice: boolean): PLCcollectSettingType[] => {
  //console.debug(['orderDevice() -START source,plcOn,isDevice', source, plcOn, isDevice]);
  let plcs = source;
  if (!plcOn) {
    plcs = plcs.filter((plc) => parseInt(plc.MachineIndex) > 0);
  }
  if (isDevice) {
    const listDev = plcs
      .filter((plc) => parseInt(plc.MachineIndex) > 0)
      .sort((plc1, plc2) => (plc1.MachineNo < plc2.MachineNo ? -1 : 0));
    const listNone = plcs.filter((plc) => parseInt(plc.MachineIndex) <= 0);
    plcs = listDev.concat(listNone);
  }
  //console.debug(['orderDevice() -END ', plcs]);
  return plcs;
};

const CollectSetting: React.FC<CollectSettingProps> = (props: CollectSettingProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
  const [dlgmsg, setDlgmsg] = useState<string>('');
  const [isOrderDevice, setIsOrderDevice] = useState<boolean>(true);
  const [isDispPLC, setIsDispPLC] = useState<boolean>(false);
  const [plcSettingList, setPlcSettingList] = useState<PLCcollectSettingType[]>([]);
  const [plcSettingSource, setPlcSettingSource] = useState<PLCcollectSettingType[]>([]);
  const { login } = useContext(AppContext);

  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('CollectSetting.はい', 'はい')}
      cancel={t('CollectSetting.いいえ', 'いいえ')}
    />
  ) : null;
  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;

  useEffect(() => {
    let plcNo = 0;
    if (props.editData.PageParam && 'plcNo' in props.editData.PageParam) {
      const prm = props.editData.PageParam as { plcNo: number };
      if (prm) {
        plcNo = prm.plcNo;
      }
      props.editData.PageParam = undefined;
    }

    GetPLCcollectSettingType(plcNo).then((resp: PLCcollectSettingType[]) => {
      resp.forEach((item, index) => {
        item.id = index + 1;
        item.MachineIndex = item.MachineIndex === '' ? '0' : item.MachineIndex;
        item.UnitSymbol = item.UnitSymbol === '' ? '0' : item.UnitSymbol;
        item.LoggingPeriod = item.LoggingPeriod === '' ? '0' : item.LoggingPeriod;
        item.isEdit = false;
      });
      let temp = resp.filter((r) => r.ValID === 1);
      setPlcSettingSource(temp);
      console.debug(['GetColList,plcNo', temp, plcNo]);

      setPlcSettingList(orderDevice(temp, isDispPLC, isOrderDevice));

      props.editData.SaveFunction = saveProc;
      props.editData.IsUpdate = false;
    });
  }, [props.editData.CancelCondition]);

  const saveAction = () => {
    setDlgmsg(t('CollectSetting.保存しますか?', '保存しますか?'));
    actCfmDlg
      .open()
      .apply((_) => {
        saveProc(plcSettingSource);
      })
      .cancel(() => { });
  };
  const saveProc = (target: object): Promise<string> => {
    return new Promise((resolve, reject) => {
      const settingSource = target as PLCcollectSettingType[];
      if (settingSource) {
        SetPLCcollectSetting(settingSource.filter((item) => item.isEdit)).then((ret: number) => {
          if (ret == ErrorCode.ERR_CODE_SYSTEM_ERROR) {
            setDlgmsg(t('CollectSetting.保存時エラーが発生しました', '保存時エラーが発生しました'));
            actMsgDlg.open();
          } else if (ret == ErrorCode.ERR_CODE_RUNFLG_CHECK_ERROR) {
            setDlgmsg(t('CollectSetting.TMBee-Boxの振動行とコナンエアーが重複しています\n実行フラグを確認してください', 'TMBee-Boxの『振動』行とコナンエアーが重複しています\n実行フラグを確認してください'));
            actMsgDlg.open();
          } else {
            if (settingSource.filter((item) => item.isIotEdit).length !== 0) {
              setDlgmsg(
                t(
                  'CollectSetting.AWSへのUPLOADを実行してください',
                  '実行フラグを編集したため、AWSへのUPLOADを実行してください。'
                )
              );
              actMsgDlg.open();
            }
          }
          props.editData.IsUpdate = false;
          // props.editData.CloseSetting();
          resolve('done');
        });
      } else {
        reject('data error');
      }
    });
  };

  const cancelAction = () => {
    if (props.editData.IsUpdate) {
      setDlgmsg(
        t(
          'CollectSetting.保存していないデータを破棄します。\nよろしいですか?',
          '保存していないデータを破棄します。\nよろしいですか?'
        )
      );
      actCfmDlg
        .open()
        .apply((_) => {
          // props.editData.IsUpdate = false;
          setPlcSettingList([]);
          props.editData.UpdateCancel();
          // props.editData.CloseSetting();
        })
        .cancel(() => { });
    } else {
      // props.editData.CloseSetting();
    }
  };

  const setSortItem = (value: string) => {
    const cond = value == 'm';
    setIsOrderDevice(cond);

    setPlcSettingList(orderDevice(plcSettingSource, isDispPLC, cond));
  };

  const setPlcDisp = (value: string) => {
    const cond = value == 'd';
    setIsDispPLC(cond);

    setPlcSettingList(orderDevice(plcSettingSource, cond, isOrderDevice));
  };

  const updateFunction = (target: PLCcollectSettingType, index: number) => {
    target.isEdit = true;
    plcSettingList[index] = target;
    const sidx = plcSettingSource.findIndex(
      (item) => item.PLCNo == target.PLCNo && item.AICardNo == target.AICardNo && item.ChannelNo == target.ChannelNo
    );
    if (sidx >= 0) {
      plcSettingSource[sidx] = target;

      props.editData.Target = plcSettingSource;
      props.editData.IsUpdate = true;
    }
  };

  const updateStartTime = (devIndex: string, startTime: Date) => {
    plcSettingSource.forEach((item) => {
      if (item.MachineIndex == devIndex) {
        item.LoggingStartTime = startTime;
        item.isEdit = true;
      }
    });
    setPlcSettingList(orderDevice(plcSettingSource, isDispPLC, isOrderDevice));

    props.editData.Target = plcSettingSource;
    props.editData.IsUpdate = true;
  };

  /**
   * RSTのどれか1つしかモータ起動状態検出フラグはチェックができない
   * @param target
   * @param index
   * @param chk
   * @returns
   */
  const updateMotorSensor = (target: PLCcollectSettingType, index: number, chk: boolean): boolean => {
    // 機器で唯一の判定
    let result = false;
    const motorActive = plcSettingSource.find((item) => item.MachineNo == target.MachineNo && item.StartDet > 0);
    if (motorActive) {
      result = false;
    } else {
      target.StartDet = chk ? 1 : 0;
      updateFunction(target, index);
      result = true;
    }
    return result;
  };
  /**
   * RSTのどれか1つしか回転周波数算出センサはチェックができない
   * @param target
   * @param index
   * @param chk
   * @returns
   */
  const updateRotClc = (target: PLCcollectSettingType, index: number, chk: boolean): boolean => {
    let result = false;
    if (chk) {
      // 機器で唯一の判定
      const rotClcActive = plcSettingSource.find((item) => item.MachineNo == target.MachineNo && item.RotClc);
      if (rotClcActive) {
        result = false;
      } else {
        target.RotClc = chk;
        updateFunction(target, index);
        result = true;
      }
      return result;
    } else {
      target.RotClc = chk;
      updateFunction(target, index);
      result = true;
      return result;
    }
  };

  //console.debug(['- 画面描画開始 -', plcSettingList]);
  return (
    <>
      <Grid container direction="row" alignItems="center" style={{ margin: 2 }}>
        <Grid item xs={12}>
          {login.IsIoT ? (
            <TableContainer component={Paper} className={classes.tableContainerIoT}>
              <Table stickyHeader aria-label="featureParameter">
                <TableHead>
                  <CollectGridHeaderIoT />
                </TableHead>
                <TableBody>
                  <CollectGridBodyIoT
                    plcSettingList={plcSettingList}
                    isDispPLC={isDispPLC}
                    isOrderDevice={isOrderDevice}
                    update={updateFunction}
                    updateStartTime={updateStartTime}
                    updateMotorSensor={updateMotorSensor}
                    updateRotClc={updateRotClc}
                  />
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <TableContainer component={Paper} className={classes.tableContainer}>
              <Table stickyHeader aria-label="featureParameter">
                <TableHead>
                  <CollectGridHeader isDispPLC={isDispPLC}></CollectGridHeader>
                </TableHead>
                <TableBody>
                  <CollectGridBody
                    plcSettingList={plcSettingList}
                    isDispPLC={isDispPLC}
                    isOrderDevice={isOrderDevice}
                    update={updateFunction}
                    updateStartTime={updateStartTime}
                    updateMotorSensor={updateMotorSensor}
                    updateRotClc={updateRotClc}
                  ></CollectGridBody>
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Grid>
        <Grid item xs={12}>
          <div style={{ height: '10px' }}></div>
        </Grid>
        <Grid item xs={12}>
          <CollectSettingFooter
            onClickSaveButton={saveAction}
            onClickCancelButton={cancelAction}
            onClickAllStartTimeSetButton={setAllStartTime}
            onChangePLCDisp={setPlcDisp}
            onChangeSortItem={setSortItem}
          ></CollectSettingFooter>
        </Grid>
      </Grid>
      {cfmdlg}
      {msgdlg}
    </>
  );
};

export default CollectSetting;
